﻿// Implmentation of DB101 feedback form.
// Teamwork supports Markdown language insertions.
(function ($) {
    var efwTurnstile = require('./efw.turnstile');   // Cloudflare Turnstile widget helper (self-bootstrapping)

    // uses this utility function later.
    if (!String.prototype.hashCode) {
        String.prototype.hashCode = function () {
            var hash = 0;
            for (var i = 0; i < this.length; i++) {
                var code = this.charCodeAt(i);
                hash = ((hash << 5) - hash) + code;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        }
    }

    window._closeModal = function () {
        // hides all dialogs in this domain.
        $('.modal').modal('hide');
    }

    window._showResult = function (model) {
        if ($.gevent) {
            $('.modal').modal('hide');
            $.gevent.publish('efw.result', model); // { title: 'My Title', message: 'My message', timeout: 1000 }
        }
    }

    var $findField = function (form, field) {
        return form.find('[name=' + field + ']');
    },
    _fieldLine = function (form, field, prompt, checkVal) {
        var s = '* ' + prompt + ': ' + $findField(form, field).val() + '\n';
        if (checkVal ? !!$findField(form, field).val() : true)
            return s;
        else
            return '';
    },
        _buildDescription = function (form, site, mode) {
            switch (mode) {
                case 'calculator':
                    return _buildDescriptionCalculator(form, site);
                case 'melp':
                    return _buildDescriptionMelp(form, site);
                default:
                    return _buildDescriptionNormal(form, site);
            }
    }, 
    _buildDescriptionCalculator = function (form, site) {
        var s = '* Site: ' + site + '\n';
        s += _fieldLine(form, 'tbEmail', 'From');
        s += _fieldLine(form, 'tbTime', 'Time');
        s += _fieldLine(form, 'tbServer', 'Server');
        s += _fieldLine(form, 'tbSituation', 'Situation');
        s += _fieldLine(form, 'tbSession', 'Session');
        s += _fieldLine(form, 'tbScreen', 'Screen');
        s += _fieldLine(form, 'tbPlan', 'Plan', true);
        s += _fieldLine(form, 'tbJob', 'Job', true);
        s += _fieldLine(form, 'tbChild', 'Child', true);
        s += '\n' + $findField(form, 'tbComment').val();
        return s;
    }, _buildDescriptionNormal = function (form, site) {
        var s = '* Page: [' + $findField(form, 'tbTitle').val() + '](' + $findField(form, 'tbPath').val() + ')\n';
        s += '* Site: ' + site + '\n',
        s += _fieldLine(form, 'tbEmail', 'From');
        s += '\n' + $findField(form, 'tbComment').val();
        return s;
    },_buildDescriptionMelp = function (form, site) {
        var s = '* Page: [' + $findField(form, 'tbTitle').val() + '](' + $findField(form, 'tbPath').val() + ')\n';
        s += '* Site: ' + site + '\n',
            s += _fieldLine(form, 'tbEmail', 'From');
        s += '\n' + $findField(form, 'tbComment').val();
        return s;
    };

    $.fn.efw$feedback = function (options) {
        const salt = "porkbelly";
        var $opts = jQuery.extend({}, jQuery.fn.efw$feedback.defaults, options);

        return this.each(function () {
            let $this = $(this),
                $form = $this.find('form'), // not reliably found later.
                $submit = $this.find('[type=submit]'),
                $tsslot = $this.find('.cf-turnstile-slot'),
                config = $this.find('[name=tbConfig]').val();

            // prep the form for validation
            $this.on('dlg.initialized', function () {
                // the form element may not be present early on edit sites
                let $localform = $(this).find('form');
                $localform.logon$formvalid();
            });

            // anti-bot behavior.
            $this.on('show.bs.modal', function () {
                $submit.prop('disabled', true);
                setTimeout(function () { $submit.prop('disabled', false); }, 5000);

                // render/refresh the Turnstile widget
                efwTurnstile.mount($(this).find('.cf-turnstile-slot')[0]);
            });

            $submit.on('click', function (e) {
                e.preventDefault();

                // perform form validation
                let $localform = $(e.target).closest('form'),
                    $localslot = $localform.find('.cf-turnstile-slot'),
                    fConfig = $localform.find('[name=tbConfig]').val();

                if (!$localform.logon$formvalid('check'))
                    return;

                // require a Turnstile token (interaction-only usually resolves silently)
                var tsToken = efwTurnstile.token($localslot[0]);
                if (!tsToken) {
                    efwTurnstile.beacon(null, 'failed', 'feedback', $localslot[0]);
                    alert('validate.captcha'._local());
                    return;
                }
                efwTurnstile.beacon(null, 'solved', 'feedback', $localslot[0]);

                $submit.prop('disabled', true);
                var taskList = $opts.taskList || $findField($this, 'tbTask').val(),
                    siteName = $opts.siteName || $findField($this, 'tbSite').val(),
                    subj = $findField($this, 'tbSubject').val() || $opts.subjectDefault + ' ' + siteName,
                    validationToken = tsToken,
                    validationType = 't',   // 't' = Turnstile ('c' = legacy reCAPTCHA)
                    $data = {
                        'todo-item': {
                            content: subj,
                            description: '# ' + subj + '\n' + _buildDescription($this, siteName, $opts.mode),
                            tags: $opts.tags                        
                        },
                        validationToken: validationToken.toString(),
                        validationType: validationType
                    };

                $.ajax({
                    type: "POST",
                    // add config as query string, if specified
                    url: '/tw/tasklists/' + taskList + '/tasks.json' + (fConfig ? '?config=' + fConfig : ''),
                    data: JSON.stringify($data),
                    processData: false,
                    contentType: 'application/json; charset=UTF-8',
                    success: function () {
                        // we're down in the iframe. At this point we don't have direct access to $(this).closest('.modal') because it's in the parent.
                        var model = { title: 'general.success.title', message: 'general.feedback.thanks', timeout: 5000 };
                        if (window.parent)
                            window.parent._showResult(model); //_closeModal();
                        else
                            window._showResult(model);
                    }, error: function (xhr) {
                        console.log('efw.feedback error: ' + xhr.responseText);
                        alert('An error occurred.');
                    }, complete: function () {
                        efwTurnstile.reset($localslot[0]);   // single-use token; refresh for any retry
                    }
                });
            });
        });
    };

    $.fn.efw$feedback.defaults = {
        subjectDefault: 'Field Report from',
        tags: 'Triage',
        mode: 'normal'
    };

    // activate globally.
    $(document).ready(function () {
        $('.comment-form-3').efw$feedback();
    });
})(jQuery);